<div class="badge" [attr.aria-label]="badge?.text + ' badge'">
  <img class="badge-icon" aria-hidden="true" *ngIf="badge?.icon" [src]="badge.icon" [alt]="badge.text" />
  <div aria-hidden="true" class="badge-text">{{ badge?.text }}</div>
</div>
